import { KeycloakService } from 'keycloak-angular';

export async function logoutKeyCloakUser(keycloakService: KeycloakService) {
  localStorage.clear();
  try {
    await keycloakService.logout();
  } catch (err) {}
  keycloakService.clearToken();
  window.location.reload();
}

export function getPoolPermissionKey(pool: number, permission: string): string {
  return `${permission}-${pool}`;
}

export function getAnyPoolPermissionKey(permission: string): string {
  return getPoolPermissionKey(0, permission);
}
